<template>
  <span>
    <img :src="statusImage" :alt="rowData.firstRecipientStatus" />
    {{ rowData.firstRecipientStatus }}
  </span>
</template>

<script>
export default {
  name: 'first-status-column',
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusImage() {
      switch (this.rowData.firstRecipientStatus) {
        case 'answered':
          return require('@/assets/images/icon-answered.svg')
        case 'no answer':
          return require('@/assets/images/icon-not_answered.svg')
        case 'failed':
          return require('@/assets/images/icon-failed.svg')
        case 'busy':
          return require('@/assets/images/icon-busy.svg')
        default:
          return require('@/assets/images/icon-answered.svg')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
img {
  max-width: 20px;
  height: auto;
  margin-right: 5px;
  vertical-align: baseline;
}
</style>
